<template>
  <div style="display: contents">
    <tr>
      <td :style="{ 'padding-left': (level * 20) + 'px' }">
        <template v-if="hasChildren">
          <span @click="expanded = !expanded" class="cursor-pointer mr-2">
            <fa :icon="expanded ? 'minus' : 'plus'" />
          </span>
        </template>
        {{ product.name || product.product_master_id }}
      </td>
      <template v-for="salesLine in salesLines">
        <td 
          v-for="category in getPriceCategories(salesLine.id)" 
          :key="`${salesLine.id}_${category.id}`"
          class="text-center"
        >
          <product-price-matrix-cell
            :product-master-id="product.id"
            :sales-line-id="salesLine.id"
            :price-category-id="category.id"
            :price-category-name="category.price_category"
            :price-data="getPriceData(salesLine.id, category.id)"
            @update="handleCellUpdate"
          />
        </td>
      </template>
    </tr>
    <template v-if="expanded && hasChildren">
      <product-price-matrix-row
        v-for="child in product.children"
        :key="child.id"
        :product="child"
        :sales-lines="salesLines"
        :price-categories-by-sales-line="priceCategoriesBySalesLine"
        :level="level + 1"
        @update="handleUpdate"
      />
    </template>
  </div>
</template>

<script>
import ProductPriceMatrixCell from './ProductPriceMatrixCell'

export default {
  name: 'ProductPriceMatrixRow',
  components: {
    ProductPriceMatrixCell
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    salesLines: {
      type: Array,
      required: true
    },
    priceCategoriesBySalesLine: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      expanded: true
    }
  },
  computed: {
    hasChildren() {
      return this.product.children && this.product.children.length > 0
    }
  },
  methods: {
    getPriceCategories(salesLineId) {
      return this.priceCategoriesBySalesLine[salesLineId] || []
    },
    getPriceData(salesLineId, priceCategoryId) {
      if (this.product.prices_data && 
          this.product.prices_data[salesLineId] && 
          this.product.prices_data[salesLineId][priceCategoryId]) {
        return this.product.prices_data[salesLineId][priceCategoryId]
      }
      return null
    },
    handleCellUpdate(data) {
      this.$emit('update', this.product.id, data.sales_line_id, data.price_category_id, data)
    },
    handleUpdate(productMasterId, salesLineId, priceCategoryId, data) {
      this.$emit('update', productMasterId, salesLineId, priceCategoryId, data)
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
